import { InjectionToken } from '@angular/core';

export const LEGACY_CONFIGURATION = new InjectionToken<LegacyConfiguration>('reflaunt-auth.legacy-configuration');

export class LegacyConfiguration {
  tokenKeyName: string;
}
